module.exports = __webpack_public_path__ + "img/favorite_topic_icon.19c0a88b.svg";